// eslint-disable-next-line import/extensions
module.exports = require('./dist/loader/browser').default;
